<template>
  <div>
    <el-tooltip
      :content="showDocComponent ? '收缩文档信息' : '展开文档信息'"
      placement="left"
      :open-delay="1000"
    >
      <div
        class="position-absolute icon-expand-site cur_pointer text-white flex-align-center d-flex flex-row-center"
        :class="showDocComponent || hoverIn ? 'icon_selected' : ''"
        @click="showDocComponent = !showDocComponent"
        @mouseenter="hoverIn = true"
        @mouseleave="hoverIn = false"
      >
        <span
          :class="showDocComponent || hoverIn ? 'text-18px' : 'text-20px'"
          class="iconfont icon-line-folder"
        ></span>
        <span
          v-if="showDocComponent || hoverIn"
          class="iconfont text-12px text-white icon-yxr-yl"
        ></span>
      </div>
    </el-tooltip>

    <div
      id="tag-data"
      class="position-absolute p-10px component-container"
      v-show="showDocComponent"
    >
      <div
        class="card-title text-hex-fff text-24px h-52px w-full bg-no-repeat flex items-center pt-10px px-10px"
      >
        数据对象
      </div>
      <el-tabs v-model="activeComponents" stretch class="w-full my-20px tabs-distribution">
        <el-tab-pane label="数据对象" name="TagTreeData"></el-tab-pane>
        <el-tab-pane label="文档属性" name="BaseAttribute"></el-tab-pane>
        <el-tab-pane label="关联文件" name="FileRelational"></el-tab-pane>
      </el-tabs>
      <el-row
        :gutter="10"
        v-show="activeComponents === 'TagTreeData'"
        class="flex-align-center d-flex"
      >
        <el-col :span="17">
          <el-select
            class="w-full doc-model-tree"
            v-model="modelDocumentId"
            popper-class="document_select-popper"
            clearable
            filterable
            size="mini"
            :disabled="!treeStandBy || treeLoading"
            placeholder="模型下拉选择"
            @change="changeCurrentModel"
          >
            <el-option
              v-for="item in modelList"
              :key="item.id"
              :label="item.fileNameOrigin"
              :value="item.documentId"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="7">
          <el-select
            class="w-full doc-model-tree"
            v-model="breakdownType"
            popper-class="document_select-popper"
            filterable
            size="mini"
            :disabled="!treeStandBy || treeLoading"
            @change="changeSearchBreakdown"
            placeholder="位号树类型"
          >
            <el-option
              v-for="(item, index) in breakdownTypeList"
              :key="index"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-col>
      </el-row>
      <div
        class="w-full tree-data h-[calc(100%-194px)]"
        v-show="activeComponents === 'TagTreeData'"
      >
        <div class="mt-10px flex items-center">
          <el-input
            v-model="searchKeyword"
            size="mini"
            class="mr-5px"
            placeholder="请输入搜索内容"
            @keyup.enter.native="throttledSearchTree"
            clearable
          ></el-input>
          <el-tooltip effect="dark" content="搜索" placement="top" :open-delay="1000">
            <el-button
              class="active-color"
              type="primary"
              @click="throttledSearchTree"
              icon="iconfont icon-line-search"
            ></el-button>
          </el-tooltip>
          <el-tooltip effect="dark" content="添加" placement="top" :open-delay="1000">
            <el-button
              class="active-color"
              type="primary"
              @click="addTagRelational"
              icon="iconfont icon-line-add"
            ></el-button>
          </el-tooltip>
        </div>
        <el-card
          class="w-full mt-10px tree-card h-[calc(100%-50px)] overflow-y-auto"
          :body-style="{
            height: '100%',
            padding: '10px',
            background: 'transparent',
          }"
          v-loading="treeLoading"
        >
          <VirtualTree
            highlight-current
            :currentNodeCode="currentModelCode"
            :nodeTreeOffset="nodeTreeOffset"
            :current-node-key="currantNodeKeyId"
            class="w-full h-full"
            emptyText="暂无数据"
            :expand-on-click-node="false"
            :data="treeList"
            :props="defaultTreeProps"
            :default-expanded-keys="defaultExpandedIds"
            @node-click="hanldeNodeClick"
            v-if="treeStandBy"
            ref="virtualTree"
            node-key="businessId"
          >
            <div class="custom-tree-node text-overflow w-full" slot-scope="{ node, data }">
              <el-tooltip
                :open-delay="1000"
                :content="`${data.code}${`[${node.label}]`}`"
                placement="top"
              >
                <span v-if="data.code" class="text-overflow w100-30 text-12px"
                  >{{ data.code }} <span v-if="node.label">[{{ node.label }}]</span></span
                >
              </el-tooltip>
            </div>
          </VirtualTree>

          <el-table
            v-if="tableStandBy"
            highlight-current-row
            :data="tagTableList"
            v-loading="relationListLoading"
            border
            @row-click="hanldeNodeClick"
            ref="realTableNode"
            row-key="code"
            :height="tagTableHeight"
            class="w-full doc-model-table"
          >
            <el-table-column prop="name" label="名称">
              <template slot-scope="scope">
                <span class="stand-tree-cell" style="color: #fff !important">
                  {{ scope.row.name }} [{{ scope.row.code }}]
                </span>
              </template>
            </el-table-column>
            <el-table-column width="50" label="操作">
              <template slot-scope="scope">
                <el-tooltip content="解除关联关系" placement="top" effect="dark">
                  <!-- content to trigger tooltip here -->
                  <el-button
                    type="primary"
                    size="small"
                    class="iconfont icon-bg-link mr-5px"
                    @click="reliveRelational(scope.row)"
                  ></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
          <div class="pt-10px tr" v-if="tableStandBy">
            <el-pagination
              background
              @size-change="searchByKeyword()"
              @current-change="searchByKeyword()"
              :current-page.sync="tagTablePage.pageNo"
              :page-size.sync="tagTablePage.pageSize"
              :page-sizes="$pageSizeAll"
              :pager-count="5"
              layout="total, pager"
              :total="tagTablePage.total"
            ></el-pagination>
          </div>
        </el-card>
      </div>
      <!-- 文档属性 -->
      <div
        class="w-full mt-10px p-10px base-attr h-[calc(100%-150px)] overflow-y-auto"
        v-show="activeComponents === 'BaseAttribute'"
      >
        <div class="flex justify-start item-start mb-10px">
          <span class="text-16px text-white custom-shadow ml-4px"> 基本属性 </span>
        </div>
        <div
          class="mb-10px text-white border-2px p-10px rounded-5px border-[#409eff]"
          v-if="classTypeTableData.length > 0"
        >
          <div
            class="flex text-12px leading-24px"
            v-for="(item, index) in classTypeTableData"
            :key="index"
          >
            <div class="text-[#c3c3c3]">{{ item.name }}：</div>
            <el-tooltip
              :content="item.value"
              placement="top"
              :open-delay="500"
              :disabled="!item.value"
            >
              <div class="flex-1 truncate">{{ attrData[item.value] }}</div>
            </el-tooltip>
          </div>
        </div>
        <div class="flex justify-start item-start mb-10px">
          <span class="text-16px text-white custom-shadow ml-4px"> 文档通用属性 </span>
        </div>
        <div
          class="mb-10px text-white border-2px p-10px rounded-5px border-[#409eff]"
          v-if="attributeList.length > 0"
        >
          <div
            class="flex text-12px leading-24px"
            v-for="(item, index) in attributeList"
            :key="index"
          >
            <div class="text-[#c3c3c3]">{{ item.name }}：</div>
            <el-tooltip
              :content="item.value"
              placement="top"
              :open-delay="500"
              :disabled="!item.value"
            >
              <div class="flex-1 truncate">{{ item.value }}</div>
            </el-tooltip>
          </div>
        </div>
        <div class="flex justify-start item-start mb-10px" v-if="templateAttrSetList.length > 0">
          <img src="../../../../resource/assets/images/titleIcon.png" alt="" />
          <span class="text-16px text-white custom-shadow ml-4px"> {{ collapseActiveName }} </span>
        </div>
        <div
          class="mb-10px text-white border-2px p-10px rounded-5px border-[#409eff]"
          v-if="templateAttrSetList.length > 0"
        >
          <div
            class="flex text-12px leading-24px"
            v-for="(item, index) in templateAttrSetList"
            :key="index"
          >
            <div
              class="w-full d-flex mb-5px"
              v-for="attr in item.attrValueList"
              :key="attr.fieldName"
              v-show="!_.isEmpty(item.attrValueList)"
            >
              <div class="text-[#c3c3c3]">{{ attr.attrbuteDetail.displayName }}：</div>
              <el-tooltip
                :content="attr.attrValue"
                placement="top"
                :open-delay="500"
                :disabled="!attr.attrValue"
              >
                <div class="flex-1 truncate">{{ attr.attrValue }}</div>
              </el-tooltip>
            </div>
          </div>
        </div>
        <!-- <el-collapse v-model="collapseActiveName">
          <el-collapse-item
            :title="item.attributeTemplate.name"
            :name="item.attributeTemplate.id"
            v-for="(item, index) in templateAttrSetList"
            :key="index + 's'"
          >
            <div class="w-full h-full collapse-text" v-show="!_.isEmpty(item.attrValueList)">
              <div
                class="w-full d-flex mb-5px"
                v-for="attr in item.attrValueList"
                :key="attr.fieldName"
              >
                <span class="text-title">{{ attr.attrbuteDetail.displayName }}：</span>
                <span class="ell w-full">{{ attr.attrValue }}</span>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse> -->
      </div>
      <div
        class="w-full mt-10px p-10px file-data h-[calc(100%-150px)] overflow-y-auto"
        v-show="activeComponents === 'FileRelational'"
      >
        <div class="flex justify-start item-start mb-10px">
          <span class="text-16px text-white custom-shadow ml-4px"> 实现文件 </span>
        </div>
        <div class="mb-10px text-white border-2px p-10px rounded-5px border-[#409eff]">
          <div
            class="w-full d-flex mb-5px flex-row-center text-12px !justify-between"
            :key="item.fileId"
            v-for="item in fileRealizationList"
          >
            <el-tooltip
              :content="`${item.fileNameOrigin}[${item.documentName}]`"
              placement="top"
              :open-delay="1000"
            >
              <span class="file-name-title ell pt-6px"
                >{{ item.fileNameOrigin }}[{{ item.documentName }}]</span
              >
            </el-tooltip>
            <span class="flex">
              <el-tooltip content="预览" placement="top" :open-delay="1000">
                <el-button
                  type="primary"
                  size="small"
                  @click="watchOriginFile(item, 1)"
                  class="iconfont icon-line-show"
                ></el-button>
              </el-tooltip>
              <el-tooltip content="下载原文件" placement="top" :open-delay="1000">
                <el-button
                  type="primary"
                  size="small"
                  @click="watchOriginFile(item, 2)"
                  class="iconfont icon-line-download"
                ></el-button>
              </el-tooltip>
            </span>
          </div>
        </div>
        <div class="flex justify-start item-start mb-10px">
          <span class="text-16px text-white custom-shadow ml-4px"> 关联文件 </span>
        </div>
        <div class="mb-10px text-white border-2px p-10px rounded-5px border-[#409eff]">
          <div
            class="w-full d-flex mb-5px flex-row-center text-12px !justify-between"
            :key="item.fileId"
            v-for="item in relationFileList"
          >
            <el-tooltip :content="item.fileName" placement="top" :open-delay="1000">
              <span class="file-name-title ell pt-6px"
                >{{ item.fileName }}[{{ item.documentName }}]</span
              >
            </el-tooltip>
            <span class="flex">
              <el-tooltip content="预览" placement="top" :open-delay="1000">
                <el-button
                  type="primary"
                  size="small"
                  @click="watchOriginFile(item, 1)"
                  class="iconfont icon-line-show"
                ></el-button>
              </el-tooltip>
              <!-- <el-tooltip content="分屏查看" placement="top" :open-delay="1000">
                    <el-button
                      type="primary"
                      size="small"
                      class="iconfont icon-bg-next"
                      @click="splitScreen(item)"
                    ></el-button>
                  </el-tooltip> -->
            </span>
          </div>
        </div>
      </div>
    </div>
    <!-- 新增关联关系start -->
    <el-dialog
      :close-on-click-modal="false"
      title="新增关联关系"
      :modal-append-to-body="false"
      :visible.sync="tagRelatedVisible"
      :before-close="cancelSaveRelation"
      :append-to-body="false"
    >
      <div class="p-10px">
        <div class="pb-10px">
          <span class="text-14px text-white">类别：</span>
          <el-select
            v-model="createTagRelatedConditions.className"
            filterable
            clearable
            class="w-200px"
            popper-class="select-tree"
            ref="docEditSelect"
            size="small"
            @clear="clearValue()"
          >
            <el-option
              :label="classDocName"
              :value="createTagRelatedConditions.className"
              hidden
            ></el-option>
            <el-tree
              :data="typeOptions"
              :props="{
                label: 'name',
                children: 'children',
              }"
              node-key="id"
              @node-click="handleDocEditTreeClick"
              highlight-current
              class="tree"
            >
            </el-tree>
          </el-select>
          <!-- <el-cascader
            size="small"
            popper-class="document_select-popper"
            :options="typeOptions"
            :props="typeOptionsProps"
            v-model="createTagRelatedConditions.className"
            placeholder="请选择"
            :show-all-levels="false"
            :change-on-select="true"
            filterable
            clearable
          ></el-cascader> -->
          <el-input
            size="small"
            style="width: 200px"
            v-model.trim="createTagRelatedConditions.code"
            @keyup.native.enter="searchRelationList()"
            class="ml-10px"
            clearable
            placeholder="请输入位号的编码或名称"
          ></el-input>
          <el-button size="small" class="ml-10px" type="primary" @click="searchRelationList()"
            >搜索</el-button
          >
        </div>
        <el-table
          highlight-current-row
          :data="relationTableData"
          v-loading="relationListLoading"
          border
          height="400px"
          @selection-change="selectionChange"
          class="w-full doc-add-table"
        >
          <el-table-column type="selection" width="40"></el-table-column>
          <el-table-column prop="nameSpace" label="命名空间"></el-table-column>
          <el-table-column prop="code" label="代码"></el-table-column>
          <el-table-column prop="name" label="名称"></el-table-column>
          <el-table-column prop="className" label="类别"></el-table-column>
        </el-table>
        <div class="pt-20px text-right">
          <el-pagination
            background
            @size-change="searchRelationList()"
            @current-change="findRelationList()"
            :current-page.sync="relationPage.pageNo"
            :page-size.sync="relationPage.pageSize"
            :page-sizes="$pageSizeAll"
            :pager-count="5"
            layout="total, sizes, prev, pager, next"
            :total="relationPage.pageTotal"
          ></el-pagination>
        </div>
        <div slot="footer" class="dialog-footer pt-20px text-center">
          <el-button @click="cancelSaveRelation()">取消</el-button>
          <el-button type="primary" @click="saveRelation()">保存</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 新增关联关系end -->
    <!-- 文件预览 -->
    <el-dialog
      :title="`${previewFileName}`"
      :visible.sync="centerDialogVisible"
      :modal="false"
      :close-on-click-modal="false"
      v-dialogDrag
    >
      <img
        :src="previewVersionTag === 0 ? 'static/img/gz/在用.png' : 'static/img/gz/弃用.png'"
        alt
        v-if="versionManagement === 'true'"
        class="position-absolute"
        style="right: 10px; top: 65px"
      />
      <!-- 图片预览 -->
      <div
        class="w-full h-full flex justify-center"
        v-if="imgTypeList.includes(previewSvgType.toLowerCase())"
      >
        <img v-move :src="resourceUrl" id="splitImg" class="h-[calc(100% - 100px)]" />
      </div>
      <p v-if="previewSvgType === 'pdf'" class="height-20 text-14px has-text-right text-color-blue">
        操作提示：Ctrl + 鼠标滚轮中键 可放大缩小
      </p>
      <iframe
        v-if="previewSvgType === 'wizdrawing' && showIframe"
        ref="htFrame"
        :src="htPage"
        width="100%"
        height="100%"
        class="myiframe"
        allowfullscreen
        @load="htLoad"
      ></iframe>
      <!-- pdf预览 -->
      <iframe
        v-else-if="showIframe && previewSvgType === 'pdf'"
        width="100%"
        height="100%"
        allow="autoplay"
        class="myiframe"
        allowfullscreen
        :src="`/lib/pdfjs/web/viewer.html?file=${resourceUrl}`"
      ></iframe>
      <!-- svg预览 -->
      <iframe
        width="100%"
        height="100%"
        v-else-if="showIframe && previewSvgType === 'svg'"
        id="previewSvg"
        :src="`/lib/svgView/index.html?file=${previewSvgUrl}`"
      ></iframe>
      <!-- 其他文件预览 -->
      <iframe
        :src="resourceUrl"
        width="100%"
        height="100%"
        v-else-if="
          showIframe &&
            !['svg', 'pdf'].includes(previewSvgType) &&
            !imgTypeList.includes(previewSvgType.toLowerCase())
        "
        allowfullscreen
        allow="autoplay"
        class="myiframe"
      ></iframe>
    </el-dialog>
  </div>
</template>
<script>
import ApiMixinTags from '@/assets/js/api/tags'
import fnMixins from '@/assets/js/fnMixins'
import ApiMixinDocument from '@/assets/js/api/documents'
import DocumentManagementService from '@/services/documentManagement'
import DocumentService from '@/services/DocumentService'
import SceneCenter from '@/services/sceneCenter'
import VirtualTree from '@/components/virtualScrollTree/tree'
import TagService from '@/services/tags'
import stdClassDataService from '@/services/bsApi/stdClassDataService'
import stdClassListService from '@/services/stdClassListService'

export default {
  mixins: [ApiMixinDocument, ApiMixinTags, fnMixins],
  name: 'docRelational',
  components: {
    VirtualTree,
  },
  props: {
    tagCode: {
      type: String,
      default: '',
    },
    heightObj: {
      type: Object,
      default: () => {
        return {
          minHeight: '',
          maxHeight: '',
          isZoom: false,
        }
      },
    },
    documentId: {
      type: String,
      default: '',
    },
    isIframeLoad: {
      // iframe内嵌的方式打开这些时，做的判断（内嵌的方式有加载指定的模型）
      type: Boolean,
      defalut: false,
    },
    standardId: {
      type: String,
      default: '',
    },
    modelParams: {
      type: Array,
    },
    classId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      currantNodeKeyId: '',
      throttledSearchTree: null,
      imgTypeList: ['bmp', 'jpg', 'jpeg', 'png', 'gif', 'webp'],
      modelList: [], // 模型列表
      hoverIn: false,
      nodeTreeOffset: 0,
      // 显示位号树组件
      showDocComponent: false,
      searchKeyword: '',
      // 目录树的配置项
      defaultTreeProps: {
        children: 'children',
        label: 'name',
      },
      tagTreeList: [],
      treeList: [], // 新的目录树列表
      tagTableList: [],
      tableStandBy: false,
      isLocation: false, // 是否是基于tagCode定位
      tagTablePage: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      // 文件id
      fileId: '',
      breakdownDetailId: '', // 目录树按类别展开
      conditionType: null,
      tagTreeId: '', // 目录树id
      tagTreeName: '', // 目录项名称
      tagTreeDetailId: '', //
      isKeyWordSerach: false, // true 代表 模糊搜索位号，目录项的name和code生成一颗树

      searchTagCode: '',
      currentModelCode: '',
      searchBreakdownType: '', // 按某种类型进行搜索
      breakdownTypeList: [], // 按某种类型进行搜索
      initBreakdownTypeList: [],
      defaultExpandedIds: [], // 展开树的集合
      isKeywordSearchExpandedIds: [], // 模糊搜索时存放展开节点id
      isTagCodeSearchExpandedIds: [], // code搜索时存放展开节点id
      defaultCurrentNodeKey: '', // 默认选中树节点
      treeStandBy: true,
      treeLoading: false,
      stopLoad: false,
      tagRelatedVisible: false, // 新增关联位号弹窗
      createTagRelatedConditions: {
        // 新增关联关系条件搜索
        className: '',
        code: '',
      },
      typeOptions: [],
      typeOptionsProps: {
        value: 'id',
        label: 'name',
        children: 'children',
      },
      relationListLoading: false,
      relationPage: {
        pageNo: 1,
        pageSize: 15,
        pageTotal: 0,
      },
      relationTableData: [],
      tagList: [], // 选中项
      activeComponents: 'TagTreeData', // 当前显示的组件
      attrData: {},
      collapseActiveName: ['baseAttr'], // 折叠面板显示字段
      fileActiveName: ['realizationFile', 'relevanceFile'],
      hideTemplateAttr: [
        {
          code: 'lianlu',
          attr: ['lujin'],
        },
      ], // 需要隐藏显示的模板属性
      generalAttrSet: {}, // 模板属性切换动态数据
      templateAttrSetList: [], // 模板属性切换动态数据
      fileRealizationList: [], // 文件列表
      relationFileList: [], // 关联文件列表
      modelDocumentId: '', // 文档id
      previewFileName: '',
      centerDialogVisible: false,
      previewVersionTag: 0,
      previewSvgType: '',
      showIframe: false,
      htPage: `${window.location.origin}/static/ht/htView.html`, // ht预览页面路径
      resourceUrl: '',
      scrollToSelect: false,
      htTimer: null,
      previewSvgUrl: '', // svg文件路径
      tagTableHeight: '',
      attrTemplateDic: {},
      currentTagClassId: '',
      directoryId: '',
      breakdownType: '2',
      idPathList: [],
      isLocationNode: false, // 是否定位node
      attributeList: [], // 文档通用属性
      classDocName: '',
      systemParams: localStorage.getItem('systemParams')
        ? JSON.parse(localStorage.getItem('systemParams'))
        : [],
      currentEnv: Wiz.GetModuleConfig('legacy-resource').currentEnv,
      classTypeTableData: [
        { name: '编码', value: 'code' },
        { name: '名称', value: 'name' },
        { name: '类别', value: 'className' },
        { name: '版本', value: 'revision' },
        { name: '计划交付时间', value: 'planDate' },
        { name: '实际交付时间', value: 'actualDate' },
      ],
    }
  },
  computed: {
    // 项目信息
    currentProject() {
      return this.$store.getters.currentProject || {}
    },
    versionManagement() {
      const version = _.find(this.systemParams, { parameterCode: 'versionManagement' }) || {}
      return version.parameterValue
    },
    basePath() {
      const routerBase = _.get(Wiz, 'globalSettings.globalConfig.routerBase')
      if (!routerBase) {
        return ''
        // eslint-disable-next-line no-else-return
      } else if (routerBase && Array.isArray(routerBase)) {
        return routerBase.length ? `/${routerBase[0]}` : ''
      }
      return `/${routerBase}`
    },
    isVersion() {
      return this.$route.query.isVersion
    },
  },
  watch: {
    resourceUrl() {
      this.showIframe = false
      this.$nextTick(() => {
        this.showIframe = true
      })
    },
    tagCode(val) {
      // 监听code-当前毫秒ms，点击相同的也会监听到
      const code = _.split(val, ',')[0]
      if (code && this.showDocComponent) {
        this.$nextTick(() => {
          this.positionNode(code)
        })
      }
    },
    heightObj: {
      deep: true,
      handler(val) {
        if (this.tableStandBy) {
          this.tableStandBy = false
          this.$nextTick(() => {
            setTimeout(() => {
              const currentNode = document.getElementsByClassName('tree-card')[0]
              const calc = this.heightObj.isZoom ? 70 : 50
              this.tagTableHeight = currentNode.clientHeight - calc
              this.tableStandBy = true
            }, 500)
          })
        }
      },
    },
    tableStandBy(val) {
      if (val) {
        const currentNode = document.getElementsByClassName('tree-card')[0]
        const calc = this.heightObj.isZoom ? 70 : 50
        this.tagTableHeight = currentNode.clientHeight - calc
      }
    },
    /**
     * @description: 用于控制组件的高度
     * @param {*} bol
     * @return {*}
     */

    showDocComponent(bol) {
      if (bol && this.documentId) {
        this.$nextTick(async () => {
          this.getDocInfo(this.documentId)
        })
      }
      this.$emit('showDoc', bol)
    },
    // 点选不同模型切换documentId
    documentId(val) {
      if (val && this.showDocComponent) {
        this.$nextTick(async () => {
          this.tagTreeList = []
          this.getDocInfo(val)
        })
      }
    },
  },
  methods: {
    // 获取目录树的方法
    async getModelTree() {
      this.treeLoading = true
      const res = await TagService.getDataObjectTree({
        fileId: this.modelParams[0].fileId,
        standardId: this.standardId,
        breakdownType: this.breakdownType,
      })
      this.treeLoading = false
      console.log(res, 'res-9900')
      if (res.code === 0 && res.data && res.data.items) {
        this.treeList = res.data.items
        this.treeStandBy = true
      }
    },
    clearValue() {
      this.createTagRelatedConditions.className = ''
      this.classDocName = ''
    },
    handleDocEditTreeClick(node) {
      this.createTagRelatedConditions.className = node.id
      this.classDocName = node.name
      this.$refs.docEditSelect.blur()
    },
    // 定位节点
    positionNode(code) {
      this.scrollToSelect = true
      this.defaultExpandedIds = []

      // 递归查找节点函数
      const findNode = (items, targetCode) => {
        if (!Array.isArray(items)) return null

        for (const item of items) {
          // 检查当前节点
          if (item.code === targetCode) {
            return item
          }

          // 递归检查子节点
          if (item.children && Array.isArray(item.children) && item.children.length > 0) {
            const found = findNode(item.children, targetCode)
            if (found) {
              return found
            }
          }
        }

        return null
      }

      // 使用treeList作为数据源查找节点
      const targetNode = findNode(this.treeList, code)

      if (!targetNode) {
        this.hanldeNodeClick({
          code: 'test',
        })
        // this.$emit('clearBitRelationData')
        this.$refs.virtualTree.setCurrentKey('')
        return
      }
      // this.$emit('getInfoByCode', code)
      // 节点找到，设置当前节点
      this.currantNodeKeyId = targetNode.businessId || ''
      this.currentModelCode = targetNode.code
      this.hanldeNodeClick(targetNode)

      // 重置搜索和UI状态
      this.clearSearchKeyword()

      // 使用虚拟滚动树的scrollToIndex方法实现正确的定位滚动
      this.$nextTick(() => {
        if (this.$refs.virtualTree && this.$refs.virtualTree.visibleList) {
          // 计算目标节点在visibleList中的索引
          const nodeIndex = _.findIndex(this.$refs.virtualTree.visibleList, (item) => {
            return item.data && item.data.code === code
          })

          // 如果找到索引，则滚动到该节点
          if (nodeIndex !== -1) {
            // 延迟调用，确保DOM更新完成
            setTimeout(() => {
              this.$refs.virtualTree.scrollToIndex(nodeIndex)
            }, 100)
          }
        }
      })

      this.isLocation = true
      this.searchTagCode = code
    },
    // 获取文档基本信息
    async getDocInfo(val) {
      this.modelDocumentId = val
      const modelFile = _.find(this.modelList, ['id', val])
      if (modelFile) {
        this.fileId = modelFile.defaultFileId
      }
      await this.getFileDetail(val)
      this.loadDocData()
    },
    // 解除关联关系
    reliveRelational(data) {
      this.$confirm('该操作将解除其关联关系,请确认是否要继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const params = {
            tagIdList: [data.id],
            fileId: this.modelParams[0].fileId,
          }
          const res = await DocumentService.dissolveRelationShip(params)
          if (res && res.code === 0 && res.data) {
            this.$message.success('解除成功')
            this.clearSearchKeyword()
            this.treeStandBy = false
            this.isLazy = true
            this.tagTreeList = await this.getTagNodeChild()
            this.$nextTick(() => {
              this.treeStandBy = true
            })
          }
        })
        .catch(() => {})
    },
    // 点击位号树
    hanldeNodeClick(data, node) {
      this.currentModelCode = ''
      this.$emit('getModelData', data)
      // this.$refs.virtualTree.setCurrentKey("3a196d53-32ff-226f-5b40-6d1248096ed8")
    },
    setCurrentNode(codeId) {
      console.log('setCurrentNode', codeId)
      this.currantNodeKeyId = codeId
    },
    setCurrentTableRow(code) {
      const rowDataIndex = this.tagTableList.find((val) => {
        return (val.code = code)
      })
      console.log('setCurrentTableRow', rowDataIndex, code, this.tagTableList)
      this.$refs.realTableNode.setCurrentRow(rowDataIndex)
    },
    // 获取文档信息
    loadDocData() {
      this.findDocBasicAttr()
      // this.getFileRealizationList()
      this.getRealizeFile() // 获取实现文件
      // this.getFileRelationalList()
      this.getFileReleFileList() // 获取关联文件
      this.getDocumentGeneralTemp()
    },
    // 获取文档通用属性
    async getDocumentGeneralTemp() {
      if (!this.classId) return
      const parameter = {
        classId: this.classId,
        dataId: this.documentId,
      }
      const res = await stdClassDataService.getDataById(parameter)
      if (res && res.code === 0 && res.data) {
        this.attributeList = res.data.attributeList
        this.attributeList.forEach((item) => {
          if (item.columnName === 'approve_status') {
            item.valueType = 1
            item.value =
              item.value === '0'
                ? this.$t('unreleased')
                : item.value === '1'
                ? this.$t('auditing')
                : item.value === '2'
                ? this.$t('handedOver')
                : this.$t('canceled')
          }
          if (item.value && item.value.endsWith(',')) {
            item.value = item.value.split(',')
            item.value.pop()
          }
        })
      }
    },
    // ht加载
    htLoad() {
      const $window = this.$refs.htFrame.contentWindow
      $window.init(this.resourceUrl)
      if (this.currentEnv.VUE_APP_CURRENT_PROJECT === 'GZ') {
        setTimeout(() => {
          $window.setColorChange()
        }, 500)
        this.htTimer = setInterval(() => {
          $window.setColorChange()
        }, 8000)
      }
    },
    // 分屏查看文件
    async splitScreen(data) {
      const fileType = _.last(_.split(data.fileName, '.')).toLowerCase()
      this.$emit('splitScreen', { ...data, type: fileType })
    },
    // 关联文档树结构预览
    async viewMore(data) {
      this.previewSvgType = _.last(_.split(data.fileName, '.')).toLowerCase()
      if (this.previewSvgType === 'pr') {
        // 如果是pr模型就直接跳转新的浏览器页面查看
        window.open(`/#/modelDocView?documentId=${data.documentId}`)
        return
      }
      if (this.previewSvgType === 'wizdrawing') {
        const fileRes = await DocumentService.findFileUrl({
          id: data.md5,
        })
        if (fileRes) {
          this.resourceUrl = fileRes
        }
      } else {
        this.resourceUrl = `${this.currentEnv.VUE_APP_STANDARD_SERVER}/api/std/file/${data.md5}`
      }
      this.previewFileName = data.fileName
      this.previewVersionTag = data.versionTag
      if (this.previewSvgType === 'svg') {
        this.previewSvgUrl = this.resourceUrl
        window.svgIframeId = 'previewSvg'
        window.svgFileId = data.fileId
      }
      this.centerDialogVisible = true
    },
    async watchOriginFile(data, type) {
      if (type === 1) {
        // 预览
        this.previewSvgType = _.last(_.split(data.fileName, '.')).toLowerCase()
        if (this.previewSvgType !== 'pr' && this.previewSvgType !== 'pprj') {
          // 非模型文件
          if (this.previewSvgType === 'wizdrawing') {
            const fileRes = await DocumentService.findFileUrl({
              id: data.md5,
            })
            if (fileRes) {
              this.resourceUrl = fileRes
            }
          } else {
            this.resourceUrl = `${this.currentEnv.VUE_APP_STANDARD_SERVER}/api/std/file/${data.fileId}`
          }
          this.previewFileName = data.fileNameOrigin || data.fileName
          this.previewVersionTag = data.versionTag
          if (this.previewSvgType === 'svg') {
            this.previewSvgUrl = this.resourceUrl
            window.svgIframeId = 'previewSvg'
            window.svgFileId = data.fileId
          }
          this.centerDialogVisible = true
        } else {
          // 模型文件
          // 云渲染跳转新页面预览
          const fullScreenParam = this.basePath
            ? {
                ShowClassicTop: false,
                ShowClassicLeft: false,
              }
            : {}
          window.routerTrigger = 'noCache'
          // 云渲染全屏版本
          const routerData = this.$router.resolve({
            path: `${this.basePath}/fullscreen/model-doc-view${
              Wiz.globalSettings.dynamicModules.modules['legacy-resource']?.config?.isVulkan
                ? '-vk'
                : ''
            }/index`,
            query: {
              documentId: `${data.documentId}`,
              title: encodeURIComponent(data.fileNameOrigin),
              standardId: this.$route.query.standardId || '',
              classId: this.$route.query.classId || '',
              isVersion: this.isVersion, // 是否是历史版本查看
              token: localStorage.getItem('authorization'),
              ...fullScreenParam,
            },
          })
          window.open(routerData.href, '_blank')
        }
        // if (supportType.includes(data.fileType)) {
        //   window.open(
        //     `${this.currentEnv.VUE_APP_STANDARD_SERVER}/api/std/file/${data.fileId}`
        //   )
        // } else {
        //   this.$confirm('当前无法直接预览，是否进行下载?', '提示', {
        //     confirmButtonText: '确定',
        //     cancelButtonText: '取消',
        //     type: 'warning',
        //   })
        //     .then(() => {
        //       axios({
        //         methods: 'GET',
        //         url: `${this.currentEnv.VUE_APP_STANDARD_SERVER}/api/std/file/${data.fileIdOrigin}`,
        //         responseType: 'blob',
        //       }).then((res) => {
        //         if (res.status !== 200) {
        //           this.$message.error('下载出现错误，请重试!')
        //         }
        //         if (res.data) {
        //           this.downLoadBlob({
        //             name: data.fileNameOrigin,
        //             type: res.data.type,
        //             data: res.data,
        //           })
        //         }
        //       })
        //     })
        //     .catch(() => {})
        // }
      } else {
        axios({
          methods: 'GET',
          url: `${this.currentEnv.VUE_APP_STANDARD_SERVER}/api/std/file/${data.md5Origin}`,
          responseType: 'blob',
        }).then((res) => {
          if (res.status !== 200) {
            this.$message.error('下载出现错误，请重试!')
          }
          if (res.data) {
            this.downLoadBlob({
              name: data.fileNameOrigin,
              type: res.data.type,
              data: res.data,
            })
          }
        })
      }
    },
    // 设置模板属性显示隐藏
    setTempAttrVisible(data) {
      const newData = _.map(data, (item) => {
        const temp = _.find(this.hideTemplateAttr, { code: item.attributeTemplate.code })
        _.forEach(item.attrValueList, (attr) => {
          attr.showAttr = true
          if (temp && temp.attr.includes(attr.fieldName)) {
            attr.showAttr = false
          }
        })
        return item
      })
      return newData
    },
    // 获取实现列表
    // async getFileRealizationList() {
    //   const res = await DocumentService.findFileList({
    //     documentId: this.modelDocumentId,
    //     isUnionObsoletedocument: true,
    //   })
    //   if (res && res.success && res.data) {
    //     this.fileRealizationList = res.data
    //   }
    // },
    // 获取关联文件
    // async getFileRelationalList() {
    //   const res = await DocumentManagementService.getfilejoinfilelist({
    //     siteid: this.currentProject.id,
    //     fileid: this.fileId,
    //     jointype: 0, // 未关联
    //     keyword: '',
    //     pageno: 1,
    //     pagesize: 9999,
    //   })
    //   if (res && res.code === 0 && res.data) {
    //     this.relationFileList = res.data
    //   }
    // },
    // 获取文档基本属性
    async findDocBasicAttr() {
      const res = await DocumentService.findDocAttr({
        id: this.modelDocumentId,
        standardId: this.standardId,
      })
      if (res && res.code === 0 && res.data) {
        this.attrData = res.data
      }
    },
    /**
     * @description:
     * @return {*}
     */
    async getTagNodeChild(node) {
      // const { treeConditions } = this.getParentNodeBusinessIds(node)
      const query = {
        StandardId: this.standardId,
        keyWords: this.searchKeyword,
        fileId: this.modelParams[0].fileId,
        expansionType: 1, // 1为位号树，2为文档树
        breakdownType: this.breakdownType,
        parentid: node?.data?.id || '',
        // directoryId: this.directoryId || node?.data?.businessId,
        // treeConditions: treeConditions || [],
        // isLoadTag: true, // 是否加载位号对象
        // tagCode: this.searchTagCode,
      }
      if (query.keyWords) {
        query.pageSize = this.tagTablePage.pageSize
        query.pageNo = this.tagTablePage.pageNo
      }
      const res = await TagService.getDirectoryExpansionV2(query)
      if (res && res.code === 0 && res.data) {
        this.tagTablePage.total = res.data.itemsCount
        this.conditionType = res.data.conditionType
        return _.map(res.data.items, (el) => {
          return {
            ...el,
            directoryItemId: res.data.directoryItemId,
            fieldName: res.data.fieldName,
            conditionType: res.data.conditionType,
            id: el.businessId,
          }
        })
      }
      return []
    },
    /**
     * @description: 根据当前的node,拿到父级的数据
     * @param {*} node
     * @return {*}
     */
    getParentNodeBusinessIds(node) {
      if (!node) return {}
      const treeConditions = []
      const tableConditions = {}
      while (node.level >= 1) {
        const index = _.findIndex(treeConditions, (el) => {
          return el.key === node.data.directoryItemId
        })
        if (index === -1) {
          treeConditions.unshift({
            key: node.data.directoryItemId,
            value: node.data.businessId,
          })
        }
        tableConditions[node.data.fieldName] = node.data.name
        node = node.parent
      }
      return { treeConditions, tableConditions }
    },
    /**
     * @description: 切换当前组件
     * @param {*} type 当前显示的组件
     * @return {*}
     */
    switchComponents(type) {
      this.activeComponents = type
    },
    // 新增关联位号
    addTagRelational() {
      this.tagRelatedVisible = true
      // this.getTagClassList()
      this.getParentTypeList()
      this.searchRelationList()
    },
    // 取消保存关联关系
    cancelSaveRelation() {
      this.relationPage = this.$options.data().relationPage
      this.createTagRelatedConditions = this.$options.data().createTagRelatedConditions
      this.relationTableData = this.$options.data().relationTableData
      this.tagList = this.$options.data().tagList
      this.tagRelatedVisible = false
    },
    // 获取新增关联关系类别选项
    // async getTagClassList() {
    //   const res = await DocumentService.findClassOptions({
    //     id: '',
    //   })
    //   if (res) {
    //     this.typeOptions = res
    //   }
    // },
    // 获取对象类别列表
    async getParentTypeList() {
      const parameter = {
        standard_id: this.standardId,
        data_type: 1,
      }
      const res = await stdClassListService.getClassList(parameter)
      if (res && res.code === 0 && res.data) {
        this.typeOptions = res.data.length > 0 ? this.listToTree(res.data) : []
      }
    },
    // 列表转树
    listToTree(list) {
      const result = list.reduce((prev, curr, i, arr) => {
        curr.children = arr.filter((v) => {
          return v.parentId === curr.id
        })
        if (
          curr.parentId === '00000000-0000-0000-0000-000000000000' ||
          curr.parentId === '' ||
          curr.parentId === null
        ) {
          prev.push(curr)
        }
        return prev
      }, [])
      return result
    },
    searchRelationList() {
      // 搜索关联关系列表
      this.relationPage.pageNo = 1
      this.findRelationList()
    },
    async findRelationList() {
      // 获取关联关系列表
      const params = {
        maxResultCount: this.relationPage.pageSize,
        skipCount: (this.relationPage.pageNo - 1) * this.relationPage.pageSize,
        sorting: '',
        standardId: this.standardId,
        fileId: this.modelParams[0].fileId,
        keywords: this.createTagRelatedConditions.code,
        classId: this.createTagRelatedConditions.className,
      }
      this.relationListLoading = true
      const res = await DocumentService.findRelationList(params)
      this.relationListLoading = false
      if (res && res.code === 0 && res.data) {
        this.relationTableData = res.data
        this.relationPage.pageTotal = res.totalCount
      }
    },
    // 选中项
    selectionChange(val) {
      this.tagList = _.map(val, (item) => {
        return {
          TagId: item.id,
          Code: item.code,
          Identifier: '',
        }
      })
    },
    async saveRelation() {
      // 保存关联关系
      if (_.isEmpty(this.tagList)) {
        this.$message.warning('请先勾选需要关联的项')
        return
      }
      const params = []
      const currentFile = this.fileRealizationList.find((val) => {
        return val.isDefault == true
      })
      console.log('tagList', this.tagList, this.modelParams, currentFile)
      _.map(this.tagList, (item) => {
        params.push({
          // fileId: this.modelParams[0].fileId,
          fileId: currentFile.id,
          tagId: item.TagId,
          isManual: true,
          identifier: '',
        })
      })
      this.relationListLoading = true
      const res = await DocumentService.associateTagWithDocumentFile(params)
      this.relationListLoading = false
      if (res && res.code === 0) {
        this.$message.success('保存位号成功')
        this.clearSearchKeyword()
        this.treeStandBy = false
        this.isLazy = true
        this.tagTreeList = await this.getTagNodeChild()
        this.$nextTick(() => {
          this.treeStandBy = true
        })
        this.cancelSaveRelation()
      } else {
        this.$message.warning(res.message)
      }
    },
    // 获取模型文件信息
    async getFileDetail() {
      this.clearSearchKeyword()
      this.breakdownTypeList = [
        { name: '类别', value: '1' },
        { name: '上下级', value: '2' },
      ]
    },
    // 获取实现文件
    async getRealizeFile() {
      const params = {
        id: this.documentId,
        standardId: this.standardId,
      }
      // 是否是历史版本预览
      if (this.isVersion === '1') {
        params.isVersion = true
        params.classId = this.classId
      }
      const res = await DocumentManagementService.getFileList(params)
      if (res.length > 0) {
        this.fileRealizationList = res
      } else {
        this.fileRealizationList = []
      }
    },
    // 获取关联文件
    async getFileReleFileList() {
      const res = await DocumentManagementService.getFileReleFileList({
        standardId: this.standardId,
        sourceTagId: this.modelParams[0].fileId,
        keywords: '',
        skipCount: 0,
        maxResultCount: 999,
        Sorting: '',
      })
      if (res && res.code === 0) {
        this.relationFileList = res.data
      }
    },
    // 切换模型
    async changeCurrentModel(val) {
      // 重置树数据
      this.treeList = []
      this.treeStandBy = false
      // 获取model详情
      const model = await this.getModelFileDetail(val)
      console.log(model, 'model123')
      this.modelParams[0] = model
      if (!_.isEmpty(model)) {
        this.$emit('changeModelData', model)
        // 调用新的目录树方法
        this.getModelTree()
      }
    },
    // 切换位号类别
    changeSearchBreakdown() {
      this.getModelTree()
    },
    // 清空搜索框内容
    async clearSearchKeyword() {
      this.searchKeyword = ''
      this.searchTagCode = ''
      this.breakdownDetailId = ''
      this.tableStandBy = false
      this.isLocation = false
      this.directoryId = ''
      this.treeStandBy = true
      this.initSearchCondition(false)
    },
    // 搜索树节点方法
    searchTree() {
      // 显示加载状态
      $('.tree-card .el-loading-mask').show()
      // 如果搜索关键词为空，则恢复原始树
      if (!this.searchKeyword.trim()) {
        if (this.originalTreeList) {
          this.treeList = this.originalTreeList
          this.originalTreeList = null
        }
        setTimeout(() => {
          $('.tree-card .el-loading-mask').hide()
        }, 3000)
        return
      }

      // 保存原始树数据以便恢复
      if (!this.originalTreeList) {
        this.originalTreeList = _.cloneDeep(this.treeList)
      }

      // 重置展开的节点
      this.defaultExpandedIds = []

      // 递归搜索函数 - 正确处理数组结构
      const searchRecursive = (items, keyword, parentPath = []) => {
        const result = []

        if (!Array.isArray(items)) {
          return result
        }

        for (const item of items) {
          // 创建副本
          const itemCopy = _.cloneDeep(item)
          // 检查当前节点是否匹配
          const isMatch =
            (item.name && item.name.toLowerCase().includes(keyword.toLowerCase())) ||
            (item.code && item.code.toLowerCase().includes(keyword.toLowerCase()))

          // 递归搜索子节点 - 确保childs字段正确
          let matchedChildren = []
          if (item.children && Array.isArray(item.children) && item.children.length > 0) {
            matchedChildren = searchRecursive(item.children, keyword, [
              ...parentPath,
              item.businessId,
            ])
            itemCopy.children = matchedChildren
          }

          // 如果当前节点匹配或者子节点中有匹配项，则保留该节点
          if (isMatch || (matchedChildren && matchedChildren.length > 0)) {
            // 添加当前节点和所有父节点到展开列表
            if (parentPath.length > 0) {
              this.defaultExpandedIds.push(...parentPath)
            }
            if (itemCopy.businessId) {
              this.defaultExpandedIds.push(itemCopy.businessId)
            }
            result.push(itemCopy)
          }
        }

        return result
      }

      // 执行搜索 - 确保使用正确的数据源
      const dataSource = Array.isArray(this.originalTreeList) ? this.originalTreeList : []
      const filteredTree = searchRecursive(dataSource, this.searchKeyword.trim())
      // 去重展开节点ID
      this.defaultExpandedIds = [...new Set(this.defaultExpandedIds)]
      this.treeList = filteredTree
      $('.tree-card .el-loading-mask').hide()
    },
    // 初始化搜索条件
    initSearchCondition(isKeword) {
      this.isKeyWordSerach = isKeword
      // this.conditionType = -1
      this.tagTreeId = ''
      this.tagTreeName = ''
      this.defaultExpandedIds = []
    },
    // 按关键词搜索位号树
    async searchByKeyword() {
      if (!this.isLazy && !this.searchKeyword) {
        this.treeStandBy = false
        this.isLazy = true
        this.$nextTick(() => {
          this.treeStandBy = true
        })
      }
      this.stopLoad = false
      if (this.searchKeyword) {
        this.searchBreakdownType = this.searchBreakdownType
          ? this.searchBreakdownType
          : this.breakdownTypeList[0].breakdownDetailId
        this.treeLoading = true
        this.searchTagCode = ''
        this.breakdownDetailId = this.searchBreakdownType
        this.initSearchCondition(true)
        this.treeStandBy = false
        this.tableStandBy = true
        const res = await this.getTagNodeChild()
        if (res) {
          // 处理表格数据
          this.tagTableList = res
          this.treeLoading = false
        }
      } else if (this.searchBreakdownType && !this.searchKeyword) {
        this.isLazy = true
        this.tableStandBy = false
        this.treeStandBy = true
        this.searchTagCode = ''
        this.breakdownDetailId = ''
        this.initSearchCondition(false)
        const searchTypeInfo = _.find(this.breakdownTypeList, ['value', this.searchBreakdownType])
        if (searchTypeInfo) {
          this.tagTreeName = searchTypeInfo.name
          this.tagTreeId = searchTypeInfo.id
        }
        this.breakdownDetailId = this.searchBreakdownType
        this.tagTreeList = []
        this.treeLoading = true
        this.tagTreeList = await this.getTagNodeChild()
        this.treeLoading = false
      } else {
        this.clearSearchKeyword()
        this.tagTreeList = []
        this.treeLoading = true
        this.tagTreeList = await this.getTagNodeChild()
        this.treeLoading = false
      }
    },
    // 点击模型位号搜索
    async searchByTagCode() {
      this.stopLoad = false
      this.initSearchCondition(false)
      this.breakdownDetailId =
        this.searchBreakdownType || this.breakdownTypeList[0].breakdownDetailId
      const breakdownItem = _.find(this.breakdownTypeList, (el) => {
        return el.breakdownDetailId === this.breakdownDetailId
      })
      this.directoryId = breakdownItem.value
      this.tagTreeList = []
      this.treeLoading = true
      const res = await this.getBreakDownList()
      if (!_.isEmpty(res[0].idPath)) {
        this.searchTagCode = ''
        this.isLocation = false
        this.idPathList = res[0].idPath.split('|')
        // 查询默认列表
        const firstData = await this.getTagNodeChild()
        this.tagTreeList = _.map(firstData, (item) => {
          return {
            ...item,
            childs: null,
          }
        })
        this.defaultExpandedIds = []
        const treeId = this.idPathList.shift()
        this.defaultExpandedIds.push(treeId)
        this.isLocationNode = true
      } else {
        this.$message.warning('当前位号没有类别信息')
        this.treeLoading = false
      }
    },
    createChildNode(data) {
      _.forEach(data, (item) => {
        if (!_.isEmpty(item.childs)) {
          this.$nextTick(() => {
            const node = this.$refs.virtualTree.getNode(item.data.id)
            const newData = _.cloneDeep(item)
            this.arrangeData(item)
            node.doCreateChildren(item.childs)
            this.$set(node, 'loaded', true)
            this.$set(node, 'expanded', true)
            this.createChildNode(newData.childs)
          })
        }
      })
    },
    // 展开树节点数据获取
    filterNodeKeys(data) {
      if (!_.isEmpty(data) && !_.isNil(data) && !this.stopLoad) {
        this.isKeywordSearchExpandedIds.push(data.data.id)
        if (!_.isEmpty(data.childs)) {
          this.isTagCodeSearchExpandedIds.push(data.data.id)
          const includeCode = _.findIndex(data.childs, (item) => {
            return item.data.code === this.searchTagCode
          })
          if (!this.isKeyWordSerach && this.searchTagCode && includeCode !== -1) {
            this.stopLoad = true
            return
          }
          _.forEach(data.childs, (item) => {
            this.filterNodeKeys(item)
          })
        }
      }
    },
    // 整理接口返回数据
    arrangeData(data) {
      _.forEach(data.childs, (item, index) => {
        data.childs[index] = {
          ...item.data,
          isTag: item.isTag,
          childs: item.childs,
        }
        if (!_.isEmpty(item.childs)) {
          this.arrangeData(item)
        }
      })
    },
    // 获取目录树加载列表
    async getBreakDownList() {
      const params = {
        siteId: this.currentProject.id,
        fileId: this.modelParams[0].fileId,
        id: this.tagTreeId || '',
        name: this.tagTreeName || '',
        breakdownDetailId: this.breakdownDetailId || '',
        conditionType: this.conditionType || -1, // 位号类型
        isKeyWordSerach: this.isKeyWordSerach, // true 代表 模糊搜索位号，目录项的name和code生成一颗树
        keyword: this.searchKeyword,
        tagCode: this.searchTagCode, // 位号code
        isLocation: this.isLocation,
      }
      if (this.isKeyWordSerach) {
        params.pageIndex = this.tagTablePage.pageNo
        params.pageSize = this.tagTablePage.pageSize
      }
      if (this.tagTreeDetailId) params.detailId = this.tagTreeDetailId
      const res = await this.apiTags({
        method: 'modelBreakDown',
        params,
      })
      if (res && res.code === 0 && res.data) {
        this.initBreakdownTypeList = res.data
        if (this.isKeyWordSerach) {
          return res
        }
        return res.data
      }
      return []
    },
    // 加载位号树
    async loadNode(node, resolve) {
      if (node.level === 0) {
        return
      }
      if (!this.searchBreakdownType && node.level === 1) {
        this.tagTreeDetailId = node.data.detailId
      }
      /* 动态加载节点数据 */
      // this.breakdownDetailId = node.data.breakdownDetailId
      this.conditionType = node.data.conditionType
      this.tagTreeId = node.data.id
      this.tagTreeName = node.data.name
      this.isKeyWordSerach = false
      this.searchTagCode = ''
      let res = []
      // if (node.data.isTag) {
      //   res = await this.getTagNodeChildByTag(node.data, this.standardId)
      // } else {
      //   res = await this.getTagNodeChild(node)
      // }
      res = await this.getTagNodeChild(node)
      if (!_.isEmpty(this.idPathList)) {
        this.defaultExpandedIds.push(this.idPathList.shift())
      } else if (this.isLocationNode) {
        this.$nextTick(() => {
          this.currentModelCode = _.split(this.tagCode, ',')[0]
          this.treeLoading = false
          this.isLocationNode = false
        })
      }
      resolve(res)
    },
    async getTagNodeChildByTag(data) {
      const res = await TagService.getTagNodeChildByTag(data, this.standardId)
      if (res && res.code === 0 && res.data) {
        return _.map(res.data.items, (el) => {
          return {
            ...el,
            directoryItemId: res.data.directoryItemId,
            fieldName: res.data.fieldName,
            conditionType: res.data.conditionType,
          }
        })
      }
      return []
    },
    async getModelList() {
      const res = await this.apiDocuments({
        method: 'baseDocumentModel',
        params: {
          id: this.documentId,
        },
      })
      if (res && res.code === 0 && res.data && res.data.length) {
        return res.data
      }
      return []
    },
    /**
     * @description: 获取文件详情
     * @param {*}
     * @return {*}
     */

    async getModelFileDetail(id) {
      const res = await DocumentManagementService.getDocumentDetail({
        id,
        standardId: this.standardId,
      })
      if (res && res.code === 0 && res.data) {
        let fileDetail = {}

        _.forEach(res.data.files, (file) => {
          if (res.data.documentBaseInfo.defaultFileId === file.fileIdOrigin) {
            fileDetail = file
          }
        })
        if (_.isEmpty(fileDetail)) {
          return {}
        }
        // 文件id
        fileDetail.fileId = res.data.documentBaseInfo.defaultFileId
        // 拼接模板属性
        fileDetail.attrObject = {}
        const templateAttr = _.find(this.systemParams, (item) => {
          return item.parameterCode === 'MultipleModelTemplate'
        })
        if (!_.isEmpty(res.data.templateAttrSetList) && templateAttr) {
          const attr = _.filter(res.data.templateAttrSetList, (el) => {
            return el.attributeTemplate.code === templateAttr.parameterValue
          })
          if (!_.isEmpty(attr)) {
            _.forEach(attr[0].attrValueList, (Attr) => {
              fileDetail.attrObject[Attr.fieldName] = Attr.attrValue
            })
          }
        }
        // 提取文件类型
        fileDetail.type = _.last(_.split(fileDetail.fileName, '.')).toLowerCase()
        return fileDetail
      }
      return {}
    },
  },
  async created() {
    // 如果从场景中进来
    this.modelList = []
    if (this.$route.query.sceneId) {
      // 场景
      // 根据场景获取documentIdList
      const res = await SceneCenter.getSceneDetail({ id: this.$route.query.sceneId })
      if (res && res.code === 0 && res.data) {
        for (let i = 0; i < res.data.models.length; i++) {
          const model = res.data.models[i]
          this.modelList.push({
            id: model.modelDocumentId,
            fileName: model.modelDocumentFileName,
            defaultFileId: model.modelDocumentFileId,
          })
        }
      }
    } else {
      // 默认从模型中心
      this.modelList = await this.getModelList()
      if (!this.$route.query.documentId && !this.isIframeLoad && this.modelList.length > 0) {
        this.changeCurrentModel(this.modelList[0].id)
      }
    }

    // 初始化目录树
    this.getModelTree()

    this.showDocComponent = true

    // 初始化节流函数，3秒内最多触发一次
    this.throttledSearchTree = _.throttle(this.searchTree, 3000)
  },
}
</script>
<style lang="scss">

.model-doc-preview {
  .el-dialog__header {
    border-color: var(--systemMainColor) !important;
  }
  div.el-loading-mask {
    background-color: #0b3258 !important;
  }
}
.select-tree {
  .el-scrollbar {
    background-color: #0b3258 !important;
  }
}
.el-select-dropdown {
  border-color: #409eff !important;
}

</style>
<style lang="scss" scoped>

@import '../css/select.scss';

</style>
<style lang="scss" scoped>

@import '../css/index.scss';
.component-container {
  width: 368px;
  height: calc(100% - 140px);
  left: 35px;
  top: 66px;
  z-index: 100;
  background-image: url('../../../../resource/assets/images/container_bg.png');
  background-size: 100% 100%;
  .el-button.el-tooltip {
    width: 50px !important;
    height: 36px !important;
  }
}
.card-title {
  width: 100%;
  height: 46px;
  background-size: 100% 100%;
}
.selectColor {
  color: #00c0ff !important;
}
/deep/ .el-input__inner,
/deep/.el-input.is-disabled input {
  background-color: transparent !important;
  color: #fff !important;
  border: 1px solid #0680e9 !important;
  border-radius: 4px !important;
}
.active-color {
  background-color: #00c0ff !important;
}
.button-color {
  border: none !important;
  background-color: rgba(255, 255, 255, 0.4) !important;
}
.base-attr,
.file-data {
  background-color: transparent !important;
}
.tree-card {
  background-color: transparent !important;
  border: none !important;
}

.icon-expand-site {
  top: 66px;
  z-index: 990;
  width: 34px;
  height: 34px;
  line-height: 34px;
  text-align: center;
  border-radius: 2px 5px 5px 2px;
  background-color: rgba(0, 116, 201, 0.8);
}
/deep/ .el-collapse-item__header {
  background-color: rgba(124, 158, 196, 0.3);
  color: #fff;
  border-bottom: 1px solid rgb(124, 158, 196);
  height: 35px;
  line-height: 35px;
  border-radius: 4px;
  padding: 10px;
}
// .tag-tree {
//   overflow-y: auto;
// }
/deep/ .el-collapse {
  border: none;
  /deep/ .el-collapse-item {
    background-color: transparent;
  }
}
/deep/ .el-collapse-item div[role='tab'] {
  border-radius: 4px;
  background-color: transparent;
}
/deep/ .el-collapse-item__wrap {
  background-color: transparent;
  border: none;
}
/deep/ .el-collapse-item__content {
  padding-bottom: 0;
}
.collapse-text {
  padding: 10px;
  color: rgba(255, 255, 255, 0.7);
}
.text-title {
  width: 135px;
  text-align: right;
}
.file-name-title {
  width: 240px;
}
/deep/ .el-table__body tr.current-row > td,
/deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #193744 !important;
}
.relieve-tag {
  right: 0;
}
.icon_selected {
  background-color: #00c0ff !important;
}
.el-tree ::-webkit-scrollbar {
  background-color: #2a517e !important;
  width: 8px;
  height: 8px;
}
html ::-webkit-scrollbar-thumb {
  background-color: #c1c1c1;
  border-radius: 8px;
}
.w100-30 {
  width: calc(100% - 30px);
  display: inline-block;
}
.tree {
  background-color: #1a446e !important;
}
/deep/.el-select-dropdown {
  background-color: #1778dd !important;
}
/deep/.el-select-dropdown__list {
  background: #1778dd !important;
}
.document_select-popper /deep/.el-scrollbar__wrap {
  background-color: #1778dd !important;
}
.position-absolute {
  position: absolute;
}
.flex-row-center {
  display: flex;
  justify-content: center;
}
.flex-align-center {
  align-items: center;
}
.el-button.el-tooltip {
  width: 25px !important;
  height: 25px !important;
  padding: 0 !important;
  line-height: 1px;
}
.ell {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/deep/.el-tree-node__label {
  color: #fff !important;
}
/deep/.el-tree-node.is-current > .el-tree-node__content,
.el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  background-color: transparent !important;
}
.ell,
.text-overflow {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/deep/.el-scrollbar {
  background-color: #17689d !important;
}
/deep/.doc-model-tree.w-full.el-select.el-select--mini input.el-input__inner {
  background-color: transparent !important;
}
/deep/.doc-model-table {
  background: transparent !important;
}
/deep/.el-table tr {
  background: transparent !important;
}
/deep/.doc-model-table.el-table.w-full .el-table__header-wrapper .has-gutter div.cell {
  color: #fff !important;
}
/deep/.el-table.w-full.doc-add-table .el-table__body-wrapper .el-table__row div.cell {
  color: #fff !important;
}
/deep/.el-table.w-full.doc-add-table .el-table__header-wrapper .has-gutter div.cell {
  color: #fff !important;
}
.el-popper.document_select-popper .el-select-dropdown__item {
  background-color: #02395c !important;
  &:hover,
  &.selected {
    background-color: #067af3 !important;
  }
}
.el-popper.document_select-popper .el-select-dropdown__list {
  padding: 0 !important;
  background-color: #0a6471 !important;
}
/deep/.el-dialog__headerbtn .el-dialog__close {
  color: #fff !important;
}
/deep/.el-tabs {
  width: 100%;
  height: 48px;
  line-height: 48px;
  background-size: 100% 100%;
  background: #1e6fb5;
}
/deep/.el-tabs__nav-wrap:after {
  background-color: transparent !important;
}
/deep/.el-tabs__item.is-active {
  background-color: transparent !important;
}
/deep/.el-tabs__nav.is-stretch {
  height: 44px !important;
  align-items: center;
}
/deep/.el-tabs__active-bar {
  width: 82px !important;
  height: 3px !important;
  background-color: #409eff !important;
}
/deep/.el-card.is-always-shadow {
  box-shadow: none !important;
}
/deep/.el-dialog__wrapper {
  pointer-events: none;
}
/deep/.el-dialog {
  width: 1000px;
  height: 672px;
  background-image: url('../../../../resource/assets/images/container_bg.png') !important;
  background-size: 100% 100% !important;
  background-color: transparent !important;
  pointer-events: auto !important;
}
/deep/.el-dialog__title {
  line-height: 45px !important;
}
/deep/.el-popper.document_select-popper .el-select-dropdown__item.selected {
  background-color: #045ab5 !important;
}

</style>
